<template>
  <Modal v-model="show" :mask-closable="false"  @on-ok="deleteStock">
    <div slot="header" class="modal-header">删除房源</div>   
    <p>确定要删除该房源吗?</p>
  </Modal> 
</template>
 
<script type="text/ecmascript-6">

import { deleteStock } from "api/house"
export default {
  props:{
    n:{
      type:Number,
      default:0
    },
    stockFid:{
      type:String,
      default:''
    },
  },
  data () {
    return {
       show:false
    };
  },
  watch:{
   n(val){
     this.show = true;
   }
 },
  methods:{
    changeLoading() {
      this.loading = false;
      this.$nextTick(() => {
          this.loading = true
      })
    },
    deleteStock(){
      deleteStock({stockFid:this.stockFid}).then( res => {
        this.changeLoading();
        this.$Message.success('删除成功');
        this.show = false;
        this.$emit('refresh')
      }).catch(error => {
        this.changeLoading(); 
      })
      
   }
  }
}
</script>
